module.exports = "<p>\n  incoming-actions works!\n</p>\n"